// @TODO Use shared abstraction with server

export default class ClientWebSocketWrapper {
  constructor(connection, descriptor) {
    this.id = ClientWebSocketWrapper.ID++;
    this.connection = connection;
    this.callbacks = {};
    this.descriptor = descriptor;

    connection.onopen = () => this.dispatch("open", null);
    connection.onclose = () => this.close();
    connection.onmessage = (message) => {
      var json = JSON.parse(message.data);
      this.dispatch(json.type, json.payload);
    };
  }

  on(type, callback) {
    this.callbacks[type] = this.callbacks[type] || [];
    this.callbacks[type].push(callback);
  }

  send(type, payload) {
    return this.sendJSON(JSON.stringify({ type, payload }));
  }

  sendError(message) {
    this.sendJSON(
      JSON.stringify({ type: "ERROR", payload: { message }, error: true })
    );
  }

  sendJSON(json) {
    // Protect against concurrency cases where messages are still
    // being sent despite the underlying connection already been broken
    if (!this.closed) {
      try {
        this.connection.send(json);
      } catch (e) {
        this.close();
      }
    }
  }

  close() {
    if (!this.closed) {
      this.dispatch("close", null);
      this.closed = true;
    }
  }

  dispatch(type, payload) {
    // console.log('Received raw message type', type);
    var callbacks = this.callbacks[type] || [];
    callbacks.forEach((cb) => cb(payload));
  }
}

ClientWebSocketWrapper.ID = 0;
